<mat-dialog-content [formGroup]="calculatorForm">
  <mat-checkbox *ngFor="let checkbox of checkboxes" [formControlName]="checkbox.label">{{ checkbox.label }}</mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" (click)="onConfirm()">ENREGISTRER</button>
  <button mat-flat-button (click)="onCancel()">ANNULER</button>
</mat-dialog-actions>
